import type { AttendanceDay, AttendanceEvent } from '../api/types';

/**
 * Menormalkan respons `GET /api/attendance/me` — MURNI.
 *
 * ADA KARENA layar Riwayat memutih pada 18 Agustus 2026, pagi hari onboarding pilot.
 *
 * Server mengembalikan ARRAY telanjang `AttendanceDay[]`; klien mengetiknya sebagai objek
 * `{ days, events }`. Tidak ada satu pun endpoint di API yang pernah mengembalikan bentuk kedua —
 * jadi `data.days` dan `data.events` selalu `undefined`, dan `buildHistory(undefined, undefined)`
 * melempar `days is not iterable` DI DALAM RENDER. React membongkar seluruh pohon: layar putih,
 * tanpa pesan, tepat satu perjalanan jaringan setelah diklik.
 *
 * Beranda memakai panggilan yang sama tetapi mengubahnya di dalam `.then()`, sehingga `.catch`
 * menelannya menjadi kartu galat. Bug yang sama, dua wajah — dan yang satu tidak pernah
 * memperingatkan tentang yang lain.
 *
 * Normalisasi ditaruh di BATAS, bukan disebar sebagai penjagaan di dalam `buildHistory`:
 * melonggarkan fungsi murni agar menerima `undefined` akan menyembunyikan ketidaksepakatan ini
 * pada setiap pemanggil berikutnya, bukan hanya di sini.
 */
export interface MyAttendance {
  readonly days: readonly AttendanceDay[];
  readonly events: readonly AttendanceEvent[];
  /**
   * Benar hanya bila respons BENAR-BENAR membawa daftar event.
   *
   * Tanpa penanda ini, `events: []` berarti dua hal yang berlawanan: "hari itu memang tidak
   * punya event" dan "server tidak mengirimkan event sama sekali". Layar yang menyimpulkan
   * keadaan sesi dari yang kedua akan berkata "belum ada catatan absensi" kepada orang yang
   * sesinya sedang terbuka — lalu check-in-nya ditolak server tanpa penjelasan.
   *
   * Mengubah layar putih menjadi jawaban yang salah bukan perbaikan; ia hanya memindahkan
   * kegagalan ke tempat yang lebih sulit dilihat.
   */
  readonly eventsAvailable: boolean;
}

const KOSONG: MyAttendance = { days: [], events: [], eventsAvailable: false };

export function normalizeMyAttendance(raw: unknown): MyAttendance {
  // Bentuk yang BENAR-BENAR dikirim server hari ini: array hari, tanpa event.
  if (Array.isArray(raw)) {
    return { days: raw as readonly AttendanceDay[], events: [], eventsAvailable: false };
  }

  if (typeof raw === 'object' && raw !== null) {
    const record = raw as { days?: unknown; events?: unknown };
    // Bentuk yang diharapkan klien, bila kelak server menyediakannya. Tiap sisi diperiksa
    // TERPISAH: server yang menambahkan `days` lebih dulu tanpa `events` tidak boleh
    // menjatuhkan layar lagi.
    return {
      days: Array.isArray(record.days) ? (record.days as readonly AttendanceDay[]) : [],
      events: Array.isArray(record.events) ? (record.events as readonly AttendanceEvent[]) : [],
      eventsAvailable: Array.isArray(record.events),
    };
  }

  // `null`, string, angka — bentuk yang tidak pernah kita minta. Kosong lebih baik daripada
  // melempar: layar kosong dapat dibaca dan dilaporkan; layar putih tidak.
  return KOSONG;
}
